import { getLocalizedContent } from './localizedContent';
import { getActiveLanguage } from '../i18n';
import { DEFAULT_LANGUAGE } from '../constants/languages';

const IMAGE_CONFIG = {
  type: 'webp'
};
/**
 * Get the source URL for an image
 * @param {string} fileName - The image filename
 * @param {string} location - The image location/size ('full' or 'thumbs')
 * @returns {string} The complete image URL
 */
export const getImageSrc = (fileName, location = 'full') => {
  if (!fileName) return null;
  
  // Simple approach - just use the filename as provided and add .webp
  // Only if not already ending with .webp
  const imageFileName = fileName.toLowerCase().endsWith('.webp') 
    ? fileName 
    : `${fileName}.webp`;
  
  // Return the full URL to the image in Google Cloud Storage
  return `https://storage.googleapis.com/eladore-ruffles.appspot.com/images/${location}/${imageFileName}`;
};
/**
 * Parse multilingual content from a JSON string or object.
 * When `lang` is omitted, uses the visitor's active storefront language
 * (localStorage / i18n). Pass an explicit code (e.g. 'EN') for admin.
 * @param {string|object|null|undefined} content
 * @param {string} [lang] language code; defaults to active storefront language
 * @returns {string}
 */
export const parseMultiLangContent = (content, lang) => {
  let resolved = lang;
  if (resolved === undefined || resolved === null || resolved === '') {
    try {
      resolved = getActiveLanguage();
    } catch {
      resolved = DEFAULT_LANGUAGE;
    }
  }
  return getLocalizedContent(content, resolved, '');
};
